<template>
  <v-text-field v-model="keyword" :class="['searchfield', 'd-block', { 'w-100': !limitWidth }]" density="compact"
    hide-details prepend-inner-icon="mdi-magnify" variant="outlined" bg-color="#f8f8f8" clearable
    :placeholder="$t('text.search_in_list')" type="text" :style="limitWidth ? 'max-width: 250px;' : 'width: 100%;'" />
</template>

<script>
import debounce from "debounce";

export default {
  name: "FilterSearch",
  props: {
    limitWidth: {
      type: Boolean,
      default: true,
    },
    queryKey: {
      type: String,
      default: "filter-keyword",
    },
  },

  methods: {
    debounceValue: debounce(function (value) {
      this.$router.replace({
        query: { ...this.$route.query, [this.queryKey]: value ? value : undefined },
      });
    }, 700),
  },

  computed: {
    keyword: {
      get() {
        return this.$route.query[this.queryKey] ?? "";
      },
      set(newValue) {
        this.debounceValue(newValue);
      },
    },
  },
};
</script>
